/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminEmailsResponse,
  HTTPValidationError,
  ServiceBusJob,
} from './platformapi.schemas';

import getMatchingEmailJobsMutator from '../custom-axios-instance';
import getOrganizationEmailJobsMutator from '../custom-axios-instance';
import getUserEmailJobsMutator from '../custom-axios-instance';
import nightlyMutator from '../custom-axios-instance';
import sendEmailMutator from '../custom-axios-instance';

/**
 * Retrieves records from email_jobs and scheduled_jobs tables for given match_group_id. Uses payloads defined in job_types.py to determine mapping from payload record to user if not directly available in the payload. Currently informs admin panels.
 * @summary Get Matching Email Jobs
 */
export const getMatchingEmailJobs = (matchGroupId: number, signal?: AbortSignal) => {
  return getMatchingEmailJobsMutator<AdminEmailsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/jobs/emails/matching/${matchGroupId}`,
    method: 'GET',
    signal,
  });
};

export const getGetMatchingEmailJobsQueryKey = (matchGroupId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/jobs/emails/matching/${matchGroupId}`] as const;
};

export const getGetMatchingEmailJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMatchingEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchingEmailJobs>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMatchingEmailJobsQueryKey(matchGroupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchingEmailJobs>>> = ({ signal }) =>
    getMatchingEmailJobs(matchGroupId, signal);

  return { queryKey, queryFn, enabled: !!matchGroupId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMatchingEmailJobs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMatchingEmailJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMatchingEmailJobs>>
>;
export type GetMatchingEmailJobsQueryError = void | HTTPValidationError;

export function useGetMatchingEmailJobs<
  TData = Awaited<ReturnType<typeof getMatchingEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchingEmailJobs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMatchingEmailJobs>>,
          TError,
          Awaited<ReturnType<typeof getMatchingEmailJobs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMatchingEmailJobs<
  TData = Awaited<ReturnType<typeof getMatchingEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchingEmailJobs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMatchingEmailJobs>>,
          TError,
          Awaited<ReturnType<typeof getMatchingEmailJobs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMatchingEmailJobs<
  TData = Awaited<ReturnType<typeof getMatchingEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchingEmailJobs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Matching Email Jobs
 */

export function useGetMatchingEmailJobs<
  TData = Awaited<ReturnType<typeof getMatchingEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  matchGroupId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMatchingEmailJobs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMatchingEmailJobsQueryOptions(matchGroupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves records from email_jobs and scheduled_jobs tables for given organization_id. Currently informs admin panels.
 * @summary Get Organization Email Jobs
 */
export const getOrganizationEmailJobs = (organizationId: number, signal?: AbortSignal) => {
  return getOrganizationEmailJobsMutator<AdminEmailsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/jobs/emails/organization/${organizationId}`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationEmailJobsQueryKey = (organizationId?: number) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/jobs/emails/organization/${organizationId}`,
  ] as const;
};

export const getGetOrganizationEmailJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationEmailJobs>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationEmailJobsQueryKey(organizationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationEmailJobs>>> = ({
    signal,
  }) => getOrganizationEmailJobs(organizationId, signal);

  return { queryKey, queryFn, enabled: !!organizationId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationEmailJobs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationEmailJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationEmailJobs>>
>;
export type GetOrganizationEmailJobsQueryError = void | HTTPValidationError;

export function useGetOrganizationEmailJobs<
  TData = Awaited<ReturnType<typeof getOrganizationEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationEmailJobs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationEmailJobs>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationEmailJobs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationEmailJobs<
  TData = Awaited<ReturnType<typeof getOrganizationEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationEmailJobs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationEmailJobs>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationEmailJobs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationEmailJobs<
  TData = Awaited<ReturnType<typeof getOrganizationEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationEmailJobs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization Email Jobs
 */

export function useGetOrganizationEmailJobs<
  TData = Awaited<ReturnType<typeof getOrganizationEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationEmailJobs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationEmailJobsQueryOptions(organizationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves records from email_jobs and scheduled_jobs tables for given user_id. Currently informs admin panels.
 * @summary Get User Email Jobs
 */
export const getUserEmailJobs = (userId: number, signal?: AbortSignal) => {
  return getUserEmailJobsMutator<AdminEmailsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/jobs/emails/users/${userId}`,
    method: 'GET',
    signal,
  });
};

export const getGetUserEmailJobsQueryKey = (userId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/jobs/emails/users/${userId}`] as const;
};

export const getGetUserEmailJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEmailJobs>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserEmailJobsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserEmailJobs>>> = ({ signal }) =>
    getUserEmailJobs(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserEmailJobs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserEmailJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserEmailJobs>>>;
export type GetUserEmailJobsQueryError = void | HTTPValidationError;

export function useGetUserEmailJobs<
  TData = Awaited<ReturnType<typeof getUserEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEmailJobs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEmailJobs>>,
          TError,
          Awaited<ReturnType<typeof getUserEmailJobs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserEmailJobs<
  TData = Awaited<ReturnType<typeof getUserEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEmailJobs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEmailJobs>>,
          TError,
          Awaited<ReturnType<typeof getUserEmailJobs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserEmailJobs<
  TData = Awaited<ReturnType<typeof getUserEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEmailJobs>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User Email Jobs
 */

export function useGetUserEmailJobs<
  TData = Awaited<ReturnType<typeof getUserEmailJobs>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEmailJobs>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserEmailJobsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A task that triggers every night at 12:00 AM UTC to trigger various nightly jobs.
 * @summary Nightly
 */
export const nightly = (signal?: AbortSignal) => {
  return nightlyMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/jobs/nightly`,
    method: 'POST',
    signal,
  });
};

export const getNightlyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof nightly>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof nightly>>, TError, void, TContext> => {
  const mutationKey = ['nightly'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof nightly>>, void> = () => {
    return nightly();
  };

  return { mutationFn, ...mutationOptions };
};

export type NightlyMutationResult = NonNullable<Awaited<ReturnType<typeof nightly>>>;

export type NightlyMutationError = void;

/**
 * @summary Nightly
 */
export const useNightly = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof nightly>>, TError, void, TContext>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof nightly>>, TError, void, TContext> => {
  const mutationOptions = getNightlyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Sends an email represented by the EmailJob in the POST body. Note that using a Pydantic model extending BaseModel as a param causes automatic
validation of the request body, where email_job is a JSON object that gets decoded into the correct Python object.
 * @summary Send Email
 */
export const sendEmail = (serviceBusJob: ServiceBusJob, signal?: AbortSignal) => {
  return sendEmailMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/jobs/send_email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: serviceBusJob,
    signal,
  });
};

export const getSendEmailMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEmail>>,
    TError,
    { data: ServiceBusJob },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendEmail>>,
  TError,
  { data: ServiceBusJob },
  TContext
> => {
  const mutationKey = ['sendEmail'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendEmail>>,
    { data: ServiceBusJob }
  > = (props) => {
    const { data } = props ?? {};

    return sendEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmail>>>;
export type SendEmailMutationBody = ServiceBusJob;
export type SendEmailMutationError = void | HTTPValidationError;

/**
 * @summary Send Email
 */
export const useSendEmail = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendEmail>>,
      TError,
      { data: ServiceBusJob },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendEmail>>,
  TError,
  { data: ServiceBusJob },
  TContext
> => {
  const mutationOptions = getSendEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
